import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1f29f4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b1f29f4c&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=b1f29f4c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f29f4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f29f4c')) {
      api.createRecord('b1f29f4c', component.options)
    } else {
      api.reload('b1f29f4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1f29f4c&scoped=true", function () {
      api.rerender('b1f29f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/primer/index.vue"
export default component.exports